import { expressQuerySelector } from "../../common/html";
import { initForm } from "../molecules/form";
import { createGeneralPageEventsAndComponents } from "../technical/page-general";
import { postRequest } from "../../utils/fetch";

window.addEventListener("DOMContentLoaded", () => {
	createGeneralPageEventsAndComponents();

	const formEl = expressQuerySelector<HTMLFormElement>(document, ".technical-forgot-password-form");
	const pageLog = expressQuerySelector<HTMLElement>(document, ".technical-top-message-log");

	const showPageLogMessage = (label: string, error = false) => {
		const icon = expressQuerySelector<HTMLElement>(pageLog, ".technical-top-message-icon", true);
		const text = expressQuerySelector<HTMLElement>(pageLog, ".technical-top-message-description", true);

		pageLog.classList.toggle("m-page-log--validation", !error);
		pageLog.classList.toggle("m-page-log--error", error);

		icon.classList.toggle("icon-succes", !error);
		icon.classList.toggle("icon-error-filled", error);

		expressQuerySelector<HTMLElement>(pageLog, ".technical-top-message-description", true).innerHTML = label;
		pageLog.classList.remove("u-hide");
	};
	const submitData = (data: { [inputName: string]: string }) => {
		return postRequest<{ email: string }, { success: boolean; successLabel: string }>(
			"/apicore/authenticationapi/forgotpassword",
			{ email: data["email"] },
			{ headers: { "Content-type": "application/json; charset=utf-8" } },
		)
			.then((res) => {
				if (!res.success) return;

				forgotPasswordForm.inputs["email"].clear(true);
				showPageLogMessage(res.successLabel);
			})
			.catch((err) => showPageLogMessage(err, true));
	};

	const forgotPasswordForm = initForm(formEl, {
		onSubmitForm: submitData,
		submitOnEnter: true,
	});
});
